import { useState } from "react";

const CurrencyModal = ({ onClose }) => {
  const [currency, setCurrency] = useState("");

  const handleSaveCurrency = () => {
    if (!currency) return;

    localStorage.setItem("currency", currency);
    window.location.reload(); // Refresh to apply changes
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[999]">
      <div className="bg-white p-6 rounded-lg shadow-lg w-80">
        <h2 className="text-lg font-semibold mb-4">Choose Your Currency</h2>
        <div className="space-y-2">
          <label className="flex items-center space-x-2 cursor-pointer">
            <input
              type="radio"
              name="currency"
              value="Tzs"
              checked={currency === "Tzs"}
              onChange={() => setCurrency("Tzs")}
            />
            <span>Tzs - Tanzanian Shilling</span>
          </label>
          <label className="flex items-center space-x-2 cursor-pointer">
            <input
              type="radio"
              name="currency"
              value="USD"
              checked={currency === "USD"}
              onChange={() => setCurrency("USD")}
            />
            <span>$ USD - United States Dollar</span>
          </label>
        </div>
        <button
          onClick={handleSaveCurrency}
          className="mt-4 bg-rose-600 text-white px-4 py-2 rounded-md w-full"
        >
          OK
        </button>
      </div>
    </div>
  );
};

export default CurrencyModal;
